import React from 'react';

const Sidebar = () => (
  <section>
    <aside className="sidebar">
      <div className="card mb-4">
        <div className="card-body">
          <h4 className="card-title">About</h4>
          <p className="card-text">Etiam rhoncus. Maecenas tempus, tellus eget condimentum rhoncus, sem quam <a
            href="#">semper libero</a>, sit amet adipiscing sem neque sed ipsum. </p>
        </div>
      </div>
    </aside>

    <aside className="sidebar sidebar-sticky">
      <div className="card mb-4">
        <div className="card-body">
          <h4 className="card-title">Tags</h4>
          <a className="btn btn-light btn-sm mb-1" href="page-category.html">Recipes</a>
          <a className="btn btn-light btn-sm mb-1" href="page-category.html">Scientific Review</a>
          <a className="btn btn-light btn-sm mb-1" href="page-category.html">Lifestyle</a>
          <a className="btn btn-light btn-sm mb-1" href="page-category.html">Journeys</a>
        </div>
      </div>
      <div className="card mb-4">
        <div className="card-body">
          <h4 className="card-title">Popular stories</h4>

          <a href="post-image.html" className="d-inline-block">
            <h4 className="h6">The blind man</h4>
            <img className="card-img" src="img/2.jpg" alt=""/>
          </a>
          <time className="timeago" dateTime="2017-10-03 20:00">3 october 2017</time>
          in Lifestyle

          <a href="post-image.html" className="d-inline-block mt-3">
            <h4 className="h6">Crying on the news</h4>
            <img className="card-img" src="img/3.jpg" alt=""/>
          </a>
          <time className="timeago" dateTime="2017-07-16 20:00">16 july 2017</time>
          in Work

        </div>
      </div>
    </aside>
  </section>
)

export default Sidebar


// WEBPACK FOOTER //
// ./src/components/Sidebar.js